const config = {
	HOMEPATH: '/works',
	port: 3001,
	contentHost: '/content',
	PAGE: 'page',
	SECTION: 'section',
	// imageSizes: [1400, 1000, 700, 500]
	imageSizes: [1400]
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js